import { Modal } from "@4uhub/lib4uhub";
import { memo } from "react";
import { useSalesContract } from "../../store/contexts/SalesContractContext";
import { IModalFormProps } from "./models";

const MD_TABS = [
  "salesContractHcpInclusionRule",
  "history",
  "product",
  "substipulant",
  "attachment",
] as const;

export const ModalForm = memo(({ children }: IModalFormProps) => {
  const { open, onClose, tabName } = useSalesContract();

  const maxDialogWidth = MD_TABS.includes(tabName as (typeof MD_TABS)[number])
    ? "sm"
    : "lg";

  return (
    <Modal open={open} onClose={onClose} maxDialogWidth={maxDialogWidth}>
      {children}
    </Modal>
  );
});
